import React from "react";
import Lottie from "react-lottie"; // Import Lottie component
import PageNotFoundLottie from "../assets/Lotties/PageNotFound.json"; // Your Lottie JSON file

const PageNotFound = () => {
  const defaultOptions = {
    loop: true, // The animation will loop indefinitely
    autoplay: true, // The animation will autoplay
    animationData: PageNotFoundLottie, // Lottie JSON animation
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <div className="w-full h-screen flex flex-col justify-center items-center">
      <div className="font-bold text-3xl">Page Not Found</div>
      <div>
        <Lottie options={defaultOptions} width={"50vw"} isClickToPauseDisabled />
      </div>
    </div>
  );
};

export default PageNotFound;
